import type { CAdvertisementsTranslations } from "./pl";

export const de: CAdvertisementsTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",

  /* Search */
  searchTitle: "Suche",
  searchBtn: "Suchen",
  allTypes: "Alle Typen",
  fields: {
    keyword: "Suchbegriff",
    type: "Typ",
    priceFrom: "Preis ab",
    priceTo: "Preis bis",
  },

  /* Validation */
  validation: {
    invalidPrice: "Ungültiger Preiswert (max. 2 Dezimalstellen).",
  },

  /* Categories */
  categoriesTitle: "Kategorien",
  noCategories: "Keine Kategorien.",
  adsCount: (n) => (n === 1 ? "1 Anzeige" : `${n} Anzeigen`),

  /* Search results */
  resultsTitle: (n) =>
    n === 1 ? "1 Anzeige gefunden" : `${n} Anzeigen gefunden`,
  noAdsFound: "Keine Anzeigen, die den angegebenen Kriterien entsprechen.",
  addDate: "Hinzugefügt",
  price: "Preis",
  negotiatedPrice: "Preis verhandelbar",
  priceNotSet: "-",
  formatPrice: (value) => {
    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${value.toFixed(2)} PLN`;
    }
  },
  readMore: "Mehr lesen ->",
};
